import React from 'react';

export const LibraryContext = React.createContext({
  selectedItems: [],
  setSelectedItems: () => {},
  setContentComponent: () => {},
  api: null,
});
